import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue";
var _hoisted_1 = {
  class: "customers-dialog modal-footer"
};
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = {
  class: "d-flex fl-s-b"
};
var _hoisted_5 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SearchFilter = _resolveComponent("SearchFilter");

  var _component_el_divider = _resolveComponent("el-divider");

  var _component_CustomersTable = _resolveComponent("CustomersTable");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisibility,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.modalVisibility = $event;
    }),
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    width: "90%"
  }, _createSlots({
    title: _withCtx(function () {
      return [_ctx.isInvoiceWithoutCustomer ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.$t("customers.invoice-with-no-customer-title")), 1)) : (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.$t("customers.title")), 1))];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_4, [_createVNode(_component_SearchFilter, {
        class: "w-30",
        placeholder: _ctx.$t('customers.filter-placeholder'),
        search: _ctx.searchValue,
        "onSearchFilter:changed": _ctx.onSearch,
        onClear: _ctx.onSearch
      }, null, 8, ["placeholder", "search", "onSearchFilter:changed", "onClear"]), _createElementVNode("div", {
        class: "has-text-primary has-text-weight-bold has-cursor is-size-6",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.toggleModalVisible(_ctx.ModalStatus.CustomerCreate);
        })
      }, _toDisplayString(_ctx.$t("customers.link")), 1)]), _createVNode(_component_el_divider), _createVNode(_component_CustomersTable, {
        ref: "customersTable"
      }, null, 512)];
    }),
    _: 2
  }, [_ctx.isShowFooter ? {
    name: "footer",
    fn: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
        class: "py-5 px-6",
        onClick: _ctx.hideDialog
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        class: "py-5 px-6",
        type: "primary",
        loading: _ctx.isLoading,
        onClick: _ctx.onSave
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.save")), 1)];
        }),
        _: 1
      }, 8, ["loading", "onClick"])])];
    }),
    key: "0"
  } : undefined]), 1032, ["modelValue"])]);
}